/**
 * Password change Controller
 */
class PasswordController {
    constructor(recoveryPasswordService, $scope, $uibModal, $state, $window, $location) {
        'ngInject';
        //Exposing globals to another methods
        this.recoveryPasswordService = recoveryPasswordService;
        this.$scope = $scope;
        this.$uibModal = $uibModal;
        this.$state = $state;
        this.loading = false;
        this.passwordChange = {newPassword: null, passwordRepeat: null};
        this.haveNumber = false;
        this.haveUppercase = false;
        this.haveLowercase = false;
        this.haveSpecialCaracter = false;
        this.haveMinimumEightCaracters = false;
        this.showPasswordField = false;
        this.passwordFieldType = "password";
        this.showRepeatPasswordField = false;
        this.repeatPasswordFieldType = "password";
        this.disabledButton = true;
        this.$window = $window;
        this.$location = $location;
    }

    async changePassword() {
        this.loading = true;

        let result;
        result = await this.recoveryPasswordService.changePassword(this.passwordChange).catch(e => result = e);

        if (result.status === 200) {
            this.showPasswordChangedModal(result.data.email);
        } else if ([400, 401, 403, 409].contains(result.status))
            this.showErrorModal(result.status);
        this.loading = false;
        this.$scope.$apply();
    }

    validatePasswordField = text => {
        const HAVE_NUMBER_REGEX = /[0-9]/;
        const HAVE_UPPERCASE_REGEX = /[A-Z]/;
        const HAVE_LOWERCASE_REGEX = /[a-z]/;
        const HAVE_SPECIAL_CARACTER = /[$*&@%#!?.,:;/_+=-]/;

        this.haveNumber = HAVE_NUMBER_REGEX.test(text);
        this.haveUppercase = HAVE_UPPERCASE_REGEX.test(text);
        this.haveLowercase = HAVE_LOWERCASE_REGEX.test(text);
        this.haveSpecialCaracter = HAVE_SPECIAL_CARACTER.test(text);
        this.haveMinimumEightCaracters = text.length >= 8;

        if(this.haveNumber && this.haveUppercase && this.haveLowercase && this.haveSpecialCaracter && this.haveMinimumEightCaracters){
            this.disabledButton = false;
        }
    }

    showPasswordContent = (disable) => {

        if(disable){
            this.showPasswordField = false;
            this.passwordFieldType = "password";
        } else {
            this.showPasswordField = true;
            this.passwordFieldType = "text";
        }
    }

    showRepeatPasswordContent = (disable) => {

        if(disable){
            this.showRepeatPasswordField = false;
            this.repeatPasswordFieldType = "password";
        } else {
            this.showRepeatPasswordField = true;
            this.repeatPasswordFieldType = "text";
        }
    }

    showPasswordChangedModal(email) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'passwordChangedModal.modal.html',
            controllerAs: '$ctrl',
            size: 'sm',
            controller: ($scope, email) => {
                "ngInject";
                let $ctrl = $scope.$ctrl;

                $ctrl.email = email;
                $ctrl.ok = () => {
                    modalInstance.close();
                };
            },
            resolve: {
                email: () => email
            },

        });

        modalInstance.result.then(() => {
            this.navigateToSite();
        });
    }

    navigateToSite() {
        this.isDispositivoMobile = this.verificaSeDispositivoMobile();

        if(this.isDispositivoMobile){
            var s = JSON.stringify({fecharModal: true});
            if(window.ReactNativeWebView){
                window.ReactNativeWebView.postMessage(s);
            } else {
                window.postMessage(s, '*');
            }
        } else {
            var currentUrl =  this.$location.absUrl().split('?')[0];
            var destinationUrl = this.checkEnviromnetByUrl(currentUrl);
            this.$window.location.href = destinationUrl;
        }
    }

    checkEnviromnetByUrl(currentUrl){
        let destinationUrl;
        if(currentUrl.includes('dev') || currentUrl.includes('desen'))
            destinationUrl = 'http://autoatendimento.cloud.dev.cooperforte.coop/';
        else if(currentUrl.includes('homol') || currentUrl.includes('hmg'))
            destinationUrl = 'http://autoatendimento.cloud.homol.cooperforte.coop/';
        else if(currentUrl.includes('eleicoes'))
            destinationUrl = 'https://eleicoes2021-homol.cf.coop.br/inscricao/';
        else
            destinationUrl = 'https://autoatendimento.cf.coop.br/';

        return destinationUrl;
    }

    verificaSeDispositivoMobile = function(){
        if(navigator.userAgent.match(/Android/i) ||
            navigator.userAgent.match(/webOS/i) ||
            navigator.userAgent.match(/iPhone/i) ||
            navigator.userAgent.match(/iPad/i) ||
            navigator.userAgent.match(/iPod/i) ||
            navigator.userAgent.match(/BlackBerry/i) ||
            navigator.userAgent.match(/Windows Phone/i)) {
            return true;
        }
        else {
            return false;
        }
    }

    showErrorModal(code) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'passwordErrorModal.modal.html',
            controllerAs: '$ctrl',
            size: 'sm',
            controller: ($scope, code) => {
                "ngInject";
                let $ctrl = $scope.$ctrl;

                $ctrl.code = code;
                $ctrl.ok = () => {
                    modalInstance.close();
                };
            },
            resolve: {
                code: () => code
            }
        });

        modalInstance.result.then(() => {
            if (code > 400 && code != 409)
                this.$state.go("login")
        }, () => {
            if (code > 403 && code != 409)
                this.$state.go("login")
        });
    };
}

export default PasswordController;


// WEBPACK FOOTER //
// ./src/app/components/views/password/password.controller.js